import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import {
  clearRoutePageMeta,
  IDynamicPageMeta,
  setRoutePageMeta,
} from "./pageMetaStore";

export const useDynamicPageMeta = () => {
  const { pathname } = useLocation();

  const setPageMeta = useCallback(
    (meta: IDynamicPageMeta) => {
      setRoutePageMeta(pathname, meta);
    },
    [pathname]
  );

  const clearPageMeta = useCallback(() => {
    clearRoutePageMeta(pathname);
  }, [pathname]);

  return {
    setPageMeta,
    clearPageMeta,
  };
};
